<article class="container">
	<header class="curved-background">
		<mat-icon
			svgIcon="pm-icons:check-circle"
			style="width: 66px; height: 66px; --icon-color-red: #fff"
		></mat-icon>
		<h1>{{ type === 'checkin' ? 'Check-in realizado!' : 'Reserva realizada' }}</h1>
	</header>

	<div class="container-content">
		<article class="px-20" style="margin-top: 20px">
			<section>
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						position: relative;
					"
				>
					<div>
						<h2 class="title">Restaurante</h2>
						<p class="venue-title">{{ venue.name }}</p>
					</div>
					<div style="display: flex; gap: 21px" *ngIf="!isMobile">
						<a [href]="venue.mapsLink" target="_blank" style="flex: 1">
							<button mat-button class="normal-button" style="width: 157px">
								Ver localização
							</button>
						</a>
						<a [href]="venue.liveMenuURL" target="_blank" style="flex: 1">
							<button mat-button class="normal-button" style="width: 157px">
								Cardápio digital
							</button>
						</a>
					</div>
				</div>
			</section>

			<section>
				<ul class="card-box-shadow" style="margin-top: 24px; margin-bottom: 24px">
					<li class="card-box-shadow__item">
						<mat-icon svgIcon="pm-icons:profile" style="width: 24px; height: 24px"></mat-icon>
						{{ client.fullName }}
					</li>
					<li class="card-box-shadow__item">
						<mat-icon svgIcon="pm-icons:profile-plus" style="width: 24px; height: 24px">
						</mat-icon>
						{{ partySize }} {{ partySize === 1 ? 'pessoa' : 'pessoas' }}
					</li>
					<li class="card-box-shadow__item" *ngIf="sectionLabel">
						<mat-icon svgIcon="pm-icons:map" style="width: 24px; height: 24px"> </mat-icon>
						{{ sectionLabel }}
					</li>
					<li class="card-box-shadow__item">
						<mat-icon svgIcon="pm-icons:calendar" style="width: 24px; height: 24px"> </mat-icon>
						{{ orderDate | date: "EEEE, d 'de' MMMM" | capitalizeFirst }}
					</li>
					<li class="card-box-shadow__item">
						<mat-icon svgIcon="pm-icons:time" style="width: 24px; height: 24px"> </mat-icon>
						{{ reservationTime }}
					</li>
					<li class="card-box-shadow__item">
						<mat-icon svgIcon="pm-icons:map" style="width: 24px; height: 24px; flex-shrink: 0">
						</mat-icon>
						{{ venue.address.value }}
					</li>
				</ul>
			</section>
		</article>
	</div>

	<section *ngIf="!voucherValue">
		<div style="background: var(--celebrations-background)">
			<h2
				class="benefits-title"
				style="
					padding: 12px 20px;
					margin-bottom: 20px;
					--content-txt: #3c3c3c;
					max-width: 768px;
					margin: 0 auto;
				"
			>
				Benefícios do seu cartão
			</h2>
		</div>
		<article class="container px-20" style="max-width: 768px; margin: 24px auto">
			<ui-pm-benefits type="expansion" [benefits]="venue.benefits"></ui-pm-benefits>
		</article>

		<div style="display: flex; justify-content: center; gap: 21px" *ngIf="isMobile">
			<a [href]="venue.mapsLink" target="_blank">
				<button mat-button class="normal-button" style="width: 157px">Ver localização</button>
			</a>
			<a [href]="venue.liveMenuURL" target="_blank">
				<button mat-button class="normal-button" style="width: 157px">Cardápio digital</button>
			</a>
		</div>
	</section>

	<article class="container">
		<ui-pm-celebrations-ribbon
			*ngIf="voucherValue"
			[voucherValue]="voucherValue"
		></ui-pm-celebrations-ribbon>

		<ui-pm-footer-buttons (click)="ok.emit()">
			<button mat-raised-button color="primary" style="max-width: 768px">OK</button>
		</ui-pm-footer-buttons>
	</article>
</article>
